import type { SVGProps } from 'react';

export const SocialX = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path
        d="M12.0258 1.67264H14.1726L9.48255 7.03304L15 14.3273H10.6799L7.2962 9.90339L3.42451 14.3273H1.27646L6.29291 8.59379L1 1.67264H5.4298L8.48834 5.7163L12.0258 1.67264ZM11.2724 13.0424H12.4619L4.78343 2.89009H3.50693L11.2724 13.0424Z"
        fill="currentColor"
      />
    </svg>
  );
};
